import type {
  TMonitoringResultsMode,
  TMonitoringSelectionMode,
} from 'constants/interfaces/IMonitoringAgentDefinition';
import type { TMonitoringScheduleFrequency } from 'constants/interfaces/IMonitoringSchedule';

export interface IBuildMonitoringScheduleTitleParams {
  entities: { name: string }[],
  frequency: TMonitoringScheduleFrequency,
  selectionMode?: TMonitoringSelectionMode,
  resultsMode?: TMonitoringResultsMode,
}

const resolveScheduleTitleLabels = (
  selectionMode: TMonitoringSelectionMode = 'upstream-suppliers',
  resultsMode: TMonitoringResultsMode = 'articles',
): { entityLabelPlural: string, scanLabel: string } => {
  if (selectionMode === 'products-mixed' || resultsMode === 'regulations') {
    return {
      entityLabelPlural: 'products',
      scanLabel: 'regulation',
    };
  }

  if (resultsMode === 'financial-risk') {
    return {
      entityLabelPlural: 'suppliers',
      scanLabel: 'financial',
    };
  }

  if (resultsMode === 'ownership') {
    return {
      entityLabelPlural: 'suppliers',
      scanLabel: 'ownership',
    };
  }

  if (selectionMode === 'climate-mixed' || resultsMode === 'climate') {
    return {
      entityLabelPlural: 'sites',
      scanLabel: 'climate',
    };
  }

  return {
    entityLabelPlural: 'suppliers',
    scanLabel: 'sentiment',
  };
};

const buildMonitoringScheduleTitle = ({
  entities,
  frequency,
  selectionMode = 'upstream-suppliers',
  resultsMode = 'articles',
}: IBuildMonitoringScheduleTitleParams): string => {
  const { entityLabelPlural, scanLabel } = resolveScheduleTitleLabels(selectionMode, resultsMode);

  if (entities.length === 1) {
    return `${entities[0].name} — ${frequency} ${scanLabel} scan`;
  }

  return `${entities.length} ${entityLabelPlural} — ${frequency} ${scanLabel} scan`;
};

export default buildMonitoringScheduleTitle;
